/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import {
	TEmVatCreateRequest,
	TEmVatDeleteRequest,
	TEmVatListRequest,
	TEmVatListResponse,
	TEmVatUpdateRequest,
} from './types';
import {
	assetsInitState,
	createEmVatRequest,
	createEmVatSuccess,
	deleteEmVatRequest,
	deleteEmVatSuccess,
	getEmVatListRequest,
	getEmVatListSuccess,
	updateEmVatRequest,
	updateEmVatSuccess,
} from './reducer';

function* getEmVatListRequestWorker(action: PayloadAction<TEmVatListRequest>) {
	const { payload } = action;
	try {
		const response: TEmVatListResponse = yield call(api.emVat.getEmVatList, payload);
		yield put(getEmVatListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(assetsInitState());
	}
}

function* createEmVatRequestWorker(action: PayloadAction<TEmVatCreateRequest>) {
	const { payload } = action;
	try {
		yield call(api.emVat.createEmVat, payload);
		yield put(createEmVatSuccess());
		notificationContainer('VAT number created successfully', 'success');
		if (payload.listRequest) {
			yield put(getEmVatListRequest(payload.listRequest));
		}
	} catch (error: any) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* updateEmVatRequestWorker(action: PayloadAction<TEmVatUpdateRequest>) {
	const { payload } = action;
	try {
		yield call(api.emVat.updateEmVat, payload);
		yield put(updateEmVatSuccess());
		notificationContainer('VAT number updated successfully', 'success');
		if (payload.listRequest) {
			yield put(getEmVatListRequest(payload.listRequest));
		}
	} catch (error: any) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

function* deleteEmVatRequestWorker(action: PayloadAction<TEmVatDeleteRequest>) {
	const { payload } = action;
	try {
		yield call(api.emVat.deleteEmVat, payload);
		yield put(deleteEmVatSuccess());
		notificationContainer('VAT number deleted successfully', 'success');
		if (payload.listRequest) {
			yield put(getEmVatListRequest(payload.listRequest));
		}
	} catch (error: any) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

export function* emVatSaga() {
	yield takeEvery(getEmVatListRequest.type, getEmVatListRequestWorker);
	yield takeEvery(createEmVatRequest.type, createEmVatRequestWorker);
	yield takeEvery(updateEmVatRequest.type, updateEmVatRequestWorker);
	yield takeEvery(deleteEmVatRequest.type, deleteEmVatRequestWorker);
}
